import { buildReducer } from '../../shared';
import { newFolderEnteredAction } from '../actions/user/folderManagementActions';
import { toggleGroupExpandedAction } from '../actions/user/groupManagementActions';
import {
    createFolderCompletedAction,
    createFolderAlreadyExistsAction,
} from '../actions/data/folderManagementDataActions';
import type { AppChromeState, GroupExpandedMap } from '../state';
import { lpcPersonaCreatedAction } from '../../appstate';
import { contactEditorNewContactSaveClickedAction } from '../../hub';
import { privateDLCreatedAction } from '../../privatedlcreateedit';

export const PEOPLE_NAV_GROUP_ID = 'peopleGroup';
export const FOLDERS_GROUP_ID = 'foldersGroup';
export const DELETED_ITEMS_GROUP_ID = 'deletedItemsGroup';
export const OTHER_CONTACTS_GROUP_ID = 'otherContactsGroup';
export const GROUPS_GROUP_ID = 'groupsGroup';
export const FAVORITES_GROUP_ID = 'favoritesGroup';
export const DIRECTORY_FOLDERS_GROUP_ID = 'directoryGroup';

const defaultExpandedGroups: GroupExpandedMap = {
    [PEOPLE_NAV_GROUP_ID]: true,
    [DELETED_ITEMS_GROUP_ID]: false,
    [FOLDERS_GROUP_ID]: true,
    [OTHER_CONTACTS_GROUP_ID]: true,
    [GROUPS_GROUP_ID]: true,
    [FAVORITES_GROUP_ID]: true,
    [DIRECTORY_FOLDERS_GROUP_ID]: true,
};

const initialState: AppChromeState = {
    beingAddedFolderNames: [],
    expandedGroups: { ...defaultExpandedGroups },
};

export default buildReducer<AppChromeState>()
    .handle(newFolderEnteredAction, (state, action) => {
        return {
            ...state,
            // resetting groups to a default state after adding a new one
            expandedGroups: { ...defaultExpandedGroups },
            beingAddedFolderNames: state.beingAddedFolderNames.concat([action.payload.name]),
        };
    })
    .handleDataAction(
        createFolderCompletedAction,
        (state, action) => removeBeingAddedFolder(state, action.payload.newFolder.displayName),
        (state, action) => removeBeingAddedFolder(state, action.payload.folderName)
    )
    .handle(createFolderAlreadyExistsAction, (state, action) =>
        removeBeingAddedFolder(state, action.payload.folderName)
    )
    .handle(toggleGroupExpandedAction, (state, action) =>
        toggleGroupExpanded(state, action.payload.groupId, action.payload.isExpanded)
    )
    .handle(lpcPersonaCreatedAction, state => toggleGroupExpanded(state, FOLDERS_GROUP_ID, true))
    .handle(contactEditorNewContactSaveClickedAction, (state, action) =>
        // only call if contact editor is on CAPIv3 i.e. hubContact exists
        action.payload.hubContact ? toggleGroupExpanded(state, FOLDERS_GROUP_ID, true) : state
    )
    .handle(privateDLCreatedAction, state => toggleGroupExpanded(state, FOLDERS_GROUP_ID, true))
    .done(initialState as AppChromeState);

function toggleGroupExpanded(state: AppChromeState, groupId: string, isExpanded: boolean) {
    return {
        ...state,
        expandedGroups: {
            ...state.expandedGroups,
            [groupId]: isExpanded,
        },
    };
}

function removeBeingAddedFolder(state: AppChromeState, folderName: string): AppChromeState {
    return {
        ...state,
        beingAddedFolderNames: state.beingAddedFolderNames.filter(folder => folder !== folderName),
    };
}
export type { Action } from '../../shared';
